// @owner ClientPlatform

import React from 'react';
import {styled} from 'styled-components';
import {textStyleMixin} from './text';

const StyledPrivacyFooter = styled.div`
  /* The card region above grows to fill the space and pushes this to the bottom;
     flex-shrink: 0 keeps it from being squeezed when the card is tall. */
  flex-shrink: 0;
  text-align: center;

  display: flex;
  flex-direction: column;
  gap: 8px;

  margin-top: 20px;
  margin-bottom: 40px;

  a {
    display: block;

    ${textStyleMixin({$variant: 'caption-small-regular'})}
    color: var(--color-text-tertiary);
    text-decoration: underline;

    &:visited {
      color: var(--color-text-tertiary);
    }

    &:hover {
      color: var(--color-text-secondary);
    }
  }
`;

export const PrivacyFooter = () => (
  <StyledPrivacyFooter>
    <a target="_blank" rel="noreferrer" href="https://front.com/legal/privacy-notice">
      Privacy Notice
    </a>
    <a
      target="_blank"
      rel="noreferrer"
      href="https://front.com/legal/front-products-and-services-privacy-notice#google_user_data_privacy_notice"
    >
      Google User Data Privacy Notice
    </a>
  </StyledPrivacyFooter>
);
